export default "__VITE_ASSET__yNUSJz2O__"